import { render, staticRenderFns } from "./BoxWrapRepeat.vue?vue&type=template&id=0e3c3187&scoped=true&"
import script from "./BoxWrapRepeat.vue?vue&type=script&lang=js&"
export * from "./BoxWrapRepeat.vue?vue&type=script&lang=js&"
import style0 from "./BoxWrapRepeat.vue?vue&type=style&index=0&id=0e3c3187&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c3187",
  null
  
)

export default component.exports